import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { turnosService } from "../../services/api";
import "./MisTurnos.css";

function MisTurnos() {
  const [turnos, setTurnos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const navigate = useNavigate();

  const _nombre = localStorage.getItem("nombre");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    cargarTurnos();
  }, [navigate]);

  const cargarTurnos = async () => {
    setCargando(true);
    try {
      const respuesta = await turnosService.obtenerMisTurnos();
      setTurnos(respuesta.data);
    } catch (error) {
      console.error("Error al cargar turnos", error);
    } finally {
      setCargando(false);
    }
  };

  const cancelarTurno = async (id) => {
    if (window.confirm("Estas segura que queres cancelar este turno?")) {
      try {
        await turnosService.cancelarTurno(id);
        cargarTurnos();
      } catch (error) {
        alert("Error al cancelar el turno");
      }
    }
  };

  const obtenerColorEstado = (estado) => {
    if (estado === "Pendiente") return "estado-pendiente";
    if (estado === "Confirmado") return "estado-confirmado";
    if (estado === "Completado") return "estado-completado";
    if (estado === "Cancelado") return "estado-cancelado";
    return "";
  };

  return (
    <div className="mis-turnos-pagina">
      <div className="mis-turnos-header">
        <div className="mis-turnos-logo" onClick={() => navigate("/")}>
          <img src="/logo-glowroom.png" alt="Glowroom MVD" className="mis-turnos-logo-img" />
        </div>
        <div className="mis-turnos-acciones">
          <button className="btn-secundario" onClick={() => navigate("/")}>
            Volver al inicio
          </button>
          <button className="btn-rosa" onClick={() => navigate("/reservar")}>
            Nuevo turno
          </button>
        </div>
      </div>

      <div className="mis-turnos-contenido">
        <div className="mis-turnos-titulo-contenedor">
          <h1 className="mis-turnos-titulo">Mis turnos</h1>
          <p className="mis-turnos-subtitulo">Hola {_nombre}, estos son tus turnos reservados</p>
        </div>

        {cargando ? (
          <div className="mis-turnos-cargando">
            <div className="spinner"></div>
            <p>Cargando tus turnos...</p>
          </div>
        ) : turnos.length === 0 ? (
          <div className="mis-turnos-vacio">
            <span className="vacio-icono">✦</span>
            <h3>No tenes turnos reservados</h3>
            <p>Reserva tu primer turno y comenzamos</p>
            <button className="btn-principal" onClick={() => navigate("/reservar")}>
              Reservar turno
            </button>
          </div>
        ) : (
          <div className="mis-turnos-lista">
            {turnos.map((turno) => (
              <div key={turno.id} className="turno-card">
                <div className="turno-card-fecha">
                  <span className="turno-dia">
                    {new Date(turno.fechaHora).toLocaleDateString("es-UY", { day: "2-digit", month: "short" })}
                  </span>
                  <span className="turno-hora">
                    {new Date(turno.fechaHora).toLocaleTimeString("es-UY", { hour: "2-digit", minute: "2-digit" })}
                  </span>
                </div>

                <div className="turno-card-info">
                  <h3 className="turno-servicio">{turno.servicio}</h3>
                  {turno.notas && <p className="turno-notas">{turno.notas}</p>}
                </div>

                <div className="turno-card-derecha">
                  <span className="turno-precio">${turno.precio}</span>
                  <span className={`turno-estado ${obtenerColorEstado(turno.estado)}`}>
                    {turno.estado}
                  </span>
                  {turno.estado !== "Cancelado" && turno.estado !== "Completado" && (
                    <button
                      className="turno-cancelar"
                      onClick={() => cancelarTurno(turno.id)}
                    >
                      Cancelar
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MisTurnos;